<div class="modal-header">
  <h5 class="modal-title">Entity has dependent entities</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss('abort')" aria-label="Close">
    
  </button>
</div>
<div class="modal-body">
  <p class="mb-2">
    This entity can't be deleted since the following dependencies depends on it:
  </p>
  @if (isBulk) {
    @for (event of entities | keys; track event) {
      <p class="pt-3 pb-0">{{entityName}} : <a [href]="'/entity/'+enitityURLKey+'/'+event" target="_blank">{{event}}</a></p>
      <div class="mb-2">
        <ng-container [ngTemplateOutlet]="individualEntity" [ngTemplateOutletContext]="{ entities: entities[event] }"></ng-container>
      </div>
    }
  } @else {
    <ng-container [ngTemplateOutlet]="individualEntity" [ngTemplateOutletContext]="{ entities: entities }"></ng-container>
  }
  <p class="alert alert-danger mt-2">Warning: Force deleting will delete all the above dependencies</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.dismiss('abort')" class="btn btn-secondary" type="submit">Cancel</button>
  <button (click)="activeModal.close('proceed')" class="btn btn-primary" type="submit">Force Delete</button>
</div>
<ng-template #individualEntity let-entities='entities'>
  @for (entityType of entities | keys; track entityType) {
    <div class="card"
      >
      <div class="card-body">
        <h3>{{ entityType }}</h3>
        @for (entity of entities[entityType].entities; track entity) {
          <con-entity-primary-alert
            [entityType]="entityType"
            [entity]="entity">
          </con-entity-primary-alert>
        }
        <p class="mt-2">Total: {{ entities[entityType].count }}</p>
      </div>
    </div>
  }
</ng-template>
